import { createTheme } from '@mui/material/styles';

export const rbwTheme = createTheme({
  palette: {
    primary: {
      main: '#18487f',
      light: '#edf1f5',
      dark: '#18487f',
    },
    secondary: {
      main: '#18487f',
      light: '#ffffff',
    },
    background: {
      default: '#edf1f5',
      paper: '#edf1f5',
    },
    star: {
      empty: '#D1D5DB',
      filled: '#e6d130',
    },
    text: {
      primary: '#000000',
      secondary: '#18487f',
      disabled: 'gray',
    },
    warning: {
      main: '#ffff00',
    },
    action: {
      disabled: '#9e9e9e',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '2.25rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#18487f',
      textAlign: 'center',
    },
    h2: {
      fontSize: '1.875rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#18487f',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
      marginBottom: '1rem',
      color: '#18487f',
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#000000',
      textAlign: 'left',
      marginTop: '1em',
      marginBottom: '1em',
    },
    h6: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#000000',
    },
    caption: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#18487f',
      textAlign: 'left',
    },

    body1: {
      fontSize: '0.8rem',
      color: '#000000',
      arrowIconColor: '#FFFFFF', //for arrow in button
      priceQuoteBackground: '#edf1f5',
      ndrpSectionBackground: '#f9fafa',

    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#18487f',
          '&:hover': {
            backgroundColor: '#4d0d0f',
          },
          color: '#fff',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          color: 'rgb(55 65 81)',
          fill: '#43b02a',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          color: '#18487f',
          '&:hover': {
            color: '#243d94',
          },
          width: '1.5rem',
          height: '1.5rem',
          '&.Mui-disabled': {
            color: '#9e9e9e',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: 'rgb(17 24 39)',
          fontSize: '1rem',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        },
      },
    },
  },
});
